module.exports = __webpack_public_path__ + "Panton-Regular.b1b145f97dae.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Regular.eot
// module id = ./src/styles/fonts/Panton-Regular.eot
// module chunks = 21